export const BreadcrumbsDefProps = {
  breadcrumbs: [
    {link: '/', label: 'Root link'},
    {link: '/', label: 'Medium link'},
    {link: '/', label: 'Medium mediummmmmmmmmmmmmmm link'},
    {link: '/', label: 'Medium link'},
    {link: '/', label: 'Current Page'}
  ]
};